import { css } from '@emotion/react';
import { flex } from '@spotnana/blocks/src/utils';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const uta_container = (isSmall: boolean) => css`
  ${!isSmall ? paddings.y.superTight : paddings.y.none}
  ${flex.init}  
  ${flex.align.center}
`;
